const e = `<svg width="32" height="32" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" fill-rule="evenodd">
        <circle stroke="#DDD" stroke-width=".8" cx="16" cy="16" r="15.6" />
        <path
            d="M15.075 18.438c-.434 2.081-.965 4.076-2.539 5.118-.486-3.145.714-5.507 1.27-8.013-.95-1.458.114-4.392 2.117-3.67 2.464.89-2.135 5.42.952 5.986 3.224.59 4.538-5.1 2.54-6.95-2.887-2.673-8.405-.062-7.726 3.764.165.936 1.225 1.22.423 2.51-1.848-.374-2.4-1.702-2.328-3.475.114-2.9 2.858-4.932 5.61-5.213 3.48-.355 6.745 1.165 7.197 4.151.507 3.372-1.57 7.02-5.293 6.758-1.007-.072-1.431-.527-2.223-.966z"
            fill="#CB121A" fill-rule="nonzero" />
    </g>
</svg>`;
export {
  e as default
};
//# sourceMappingURL=pinterest-color.es.Cu7YGljk.js.map
